import { useCallback, useEffect, Dispatch, SetStateAction } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import coiffeurIcon from 'assets/icons/coiffeur-search.svg'
import { IFilteredCoiffeurSalonList } from 'types/CoiffeurType'
import { InputWrapper, StyledInputText } from './styled'

interface ICoiffeurSearchProps {
  salons: IFilteredCoiffeurSalonList[] | []
  setSearchText: Dispatch<SetStateAction<string>>
  setData: Dispatch<SetStateAction<IFilteredCoiffeurSalonList[] | []>>
  searchText: string
}

export default function CoiffeurSalonSearch({ salons, setData, searchText, setSearchText }: ICoiffeurSearchProps) {
  const { t } = useTranslation()

  // Handle change event of search input
  const handleChange = (value: string) => {
    setSearchText(value)
    filterData(value)
  }

  // Filter salons by search text
  const filterData = useCallback(
    (value: string) => {
      const includeColumns = ['name']
      const lowercasedValue = value.toLowerCase().trim()

      if (lowercasedValue === '') setData(salons)
      else {
        const filteredData = salons?.filter((item: IFilteredCoiffeurSalonList) => {
          return Object.keys(item).some((key) =>
            includeColumns.includes(key)
              ? item[key as keyof IFilteredCoiffeurSalonList].toString().toLowerCase().includes(lowercasedValue)
              : false
          )
        })
        setData(filteredData)
      }
    },
    [salons, setData]
  )

  useEffect(() => {
    filterData(searchText)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salons])

  const disabled = !salons?.length

  return (
    <InputWrapper className="p-input-icon-left">
      <img src={coiffeurIcon} alt="coiffeur-salon-search" className="input-icon" width={20} height={20} />
      <StyledInputText
        id="coiffeur-salon-search"
        disabled={disabled}
        value={searchText}
        onChange={(e) => handleChange(e.target.value)}
        placeholder={t('input-texts.search-coiffeur-salon')}
      />
    </InputWrapper>
  )
}
